<template>
  <div id="mai-conversation-root">
    <div id="mai-conversation" class="clearfix">
      <img src="" class="image">
      <div :class="[ msg.from === userId ? 'from' : 'to', 'speech-bubble mai-chat-message' ]" v-for="msg in messages" :key="msg.id">
        <div class="header">
          {{ msg.name }}
        </div>
        <component v-if="msg.componentType" :is="msg.componentType" :message="msg" @send-action="action => { $emit('send-action', action) }" />
        <div class="meta">
          {{ msg.time }}
        </div>
      </div>
    </div>
    <a id="mai-conversation-btm" href="#mai-conversation-btm"></a>
  </div>
</template>
<script>
import Time from '@/mixins/Time'
import PlainTextMessage from './PlainTextMessage'
import QuickReplyMessage from './QuickReplyMessage'
import AttachmentMessage from './AttachmentMessage'
export default {
  name: 'ChatConversation',
  mixins: [ Time ],
  components: {
    PlainTextMessage,
    QuickReplyMessage,
    AttachmentMessage
  },
  props: {
    conversationId: {
      type: Number
    },
    userId: {
      type: Number
    },
    messages: {
      type: Array
    }
  },
  watch: {
    messages: {
      deep: true,
      handler: function (newVal, oldVal) {
        this.$nextTick(this.scrollTop)
      }
    }
  },
  methods: {
    scrollTop () {
      this.$el.querySelector('#mai-conversation-btm').click()
    }
  },
  mounted () {
    document.querySelector('#mai-conversation-root').addEventListener('scroll', () => {
      console.log('here')
    })
  }
}
</script>
<style lang="scss">
#mai-conversation {
  background: #fff;
  padding: 15px;
  font-size: 16px;
  .speech-bubble {
    position: relative;
    margin: 8px 8px 20px 8px;
    padding: 15px;
    color: #444;
    border-radius: 4px;
    width: 66%;
    .header {
      position: absolute;
      bottom: 100%;
      font-size: 15px;
      font-weight: bold;
      color: #111;
    }
    .meta {
      position: absolute;
      top: 100%;
      font-size: 10px;
    }
    &.from {
      background: #e5e5e5;
      float: right;
      &:after {
        left: 5%;
      }
      .meta {
        right: 0;
      }
    }
    &.to {
      float: left;
      background: #FF8D00;
      color: #fff;
      &:after {
        right: 5%;
        transform: rotate(90deg);
      }
      .meta {
        left: 0;
        color: #444;
      }
    }
    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      width: 0;
      height: 0;
      border: 8px solid transparent;
      border-top-color: #fff;
      border-bottom: 0;
      border-left: 0;
      margin-left: -4px;
      margin-bottom: -8px;
    }
    .carousel-indicators li { visibility: hidden; }
    .el-carousel__item h3 {
      font-size: 18px;
      margin: 0;
      text-align: center;
    }
    .el-carousel__item h4 {
      font-size: 16px;
      margin: 0;
      text-align: center;
    }
  }
  .mai-chat-message {
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/sections/chat/ChatConversation.vue